
export function djangoChoicesToVuetify(arr) {
  return arr.map(([value, text]) => ({ value, text }))
}
